import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import { callSauriPayApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import { getStrLang } from '../../Translate';

// Mobile money calling-code prefix per country, keyed the same way as
// pay-easy-backend-new/config/sauripayData.ts - keep both in sync.
const SAURIPAY_COUNTRY_PREFIX = {
    cg: '243', gh: '233', ke: '254', mw: '265', ng: '234', rw: '250',
    tz: '255', ug: '256', cm: '237', bj: '229', ci: '225', sn: '221', zm: '260',
};

const SauriPay = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingSauriPayInfo, setLoadingSauriPayInfo] = useState(false);
    const [infoSauriPay, setInfoSauriPay] = useState(sessionStorage.getItem("sauripay_info") !== null ? JSON.parse(sessionStorage.getItem("sauripay_info")) : undefined);
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const country = (sessionStorage.getItem("country") || "").toLowerCase();
    const countryPrefix = SAURIPAY_COUNTRY_PREFIX[country] || "";

    useEffect(() => {
        translate();
    }, [translate]);

    const callSauriPay = () => {
        setLoadingSauriPayInfo(true);
        setIsError(false);
        const fullPhoneNumber = `${countryPrefix}${phoneNumber}`;
        callSauriPayApi(sessionStorage.getItem("order_no"), props.payment_type, fullPhoneNumber)
            .then(res => {
                setInfoSauriPay(res);
                sessionStorage.setItem("sauripay_info", JSON.stringify(res));
                setLoadingSauriPayInfo(false);
                setWaitingPayment(true);
            })
            .catch(err => {
                console.log(err.toString());
                setErrorMsg(err.response?.data?.result?.message || err.response?.data?.message ? (err.response?.data?.result?.message || err.response?.data?.message) : "Internal server error");
                setIsError(true);
                setLoadingSauriPayInfo(false);
            }).finally(() => {
                translate();
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!phoneNumber.trim()) return;
        callSauriPay();
    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingSauriPayInfo]);

    return (
        <>
            {infoSauriPay === undefined && !loadingSauriPayInfo && (
                <div className='col-md-12 d-flex justify-content-center mt-5'>
                    <form style={{ minWidth: "100%" }} onSubmit={handleSubmit}>
                        <div className='form-group'>
                            <label htmlFor="phone_number">{getStrLang(lang.nameLang, "phone_number")}</label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {countryPrefix && <span style={{ marginRight: 8 }}>+{countryPrefix}</span>}
                                <input type="tel" className='form-control' id="phone_number" name="phone_number"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "phone_number")}`}
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ''))}
                                    required />
                            </div>
                        </div>
                        <button type='submit' className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "pay")}</button>
                    </form>
                </div>
            )}

            {loadingSauriPayInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {infoSauriPay !== undefined && !loadingSauriPayInfo && !isError && (
                <div className="group-pix-content">
                    <div className="infoarea-pix">
                        <div className='infoarea-pix-message'>
                            <span data-lang-str="waiting-payment-sauripay">{getStrLang(lang.nameLang, "waiting-payment-sauripay")}</span>
                        </div>
                    </div>
                </div>
            )}

            {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <h4>{errorMsg}</h4>
            </div>}
        </>
    )
}

export default SauriPay;
